import { useAuthStore } from "@/lib/Auth/authStore";
import { resendVerification } from "@/lib/Auth/authApi";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export function useResendVerification() {
  const { token } = useAuthStore();

  return useMutation({
    mutationFn: async () => {
      if (!token) {
        throw new Error("Not authenticated");
      }
      await resendVerification(token, window.location.origin);
    },
    onSuccess: () => {
      toast.success("Verification email sent. Check your inbox.");
    },
    onError: (error) => {
      toast.error(
        error instanceof Error ? error.message : "Failed to resend code",
      );
    },
  });
}
